import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function MomSysSplitLotButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.splitLot")}</ActionButtonLayout>;

}

export default MomSysSplitLotButtonLayout;

